import { Component, OnInit, EventEmitter } from "@angular/core";
import { ConsumosService } from "../../servicios/consumos.service";
import { Consumos } from "../../entidades/entidades";
import { ComponentesRoutingModule } from "../componentes-routing.module";

@Component({
  selector: "app-consumos-grid",
  templateUrl: "./consumos-grid.component.html",
  styleUrls: ["./consumos-grid.component.css"],
})
export class ConsumosGridComponent implements OnInit {
  consumosArr: Consumos[] = [];
  selectedConsumos: Consumos;
  public consumos$ = new EventEmitter<Consumos[]>();
  constructor(private consumosService: ConsumosService) {}

  ngOnInit(): void {
    this.carga();
  }

  async carga() {
    await this.getConsumos(2);
    await this.getConsumos(61);
    await this.getConsumos(119);
    await this.getConsumos(176);
    this.consumos$.emit(this.consumosArr);
    console.log(this.consumosArr);
  }

  async getConsumos(id: number) {
    try {
      //const datoRetorno = await this.consumosService.getSingle(id).toPromise();
      //this.consumosArr.push(datoRetorno);
      this.consumosArr.push({
        id: 2,
        idMedidor: 142315,
        lecturaIni: 164,
        lecturaFin: 174,
        consumo: 136,
        idTipoConsumo: null,
        idDiametroToma: 1,
        idUsuarioCaptura: 2,
        fechaAlta: null,
        idTipoPeriodo: 2,
        anio: 2019,
        periodoIni: null,
        periodoParcialidad: 4,
        periodoFin: null,
        idTipoIngreso: null,
        idUsuarioLecturista: null,
        observaciones: null,
        idCargo: 116062,
        idAgua: 142315,
        idTipoUso: 5,
        idTipoServicio: 3,
        idCobroConcepto: null,
        idAnomalia: null,
        idEstatus: 1,
        idUsuarioAsigno: null,
        fechaAsignacion: null,
      });
    } catch (e) {
      if (e.response) throw { message: e.response.data };
      else throw e;
    } finally {
      console.log("Paso por getConsumos");
    }
  }
}
